// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"900c4e26","239":"bd0d3b55","455":"14a7f77b"}[chunkId] + ".chunk.js";
};